import { useAutocomplete } from 'admin';
import { type BuyerMaterialSpecificationAdminListItem, getMaterialComponentLabel } from 'api';
import { capitalizeString } from 'ui';

// import { getMaterialComponentLabel } from 'features';
import { AutocompleteField, type AutocompleteFieldProps } from '../AutocompleteField/AutocompleteField';

// const getMaterialComponentLabel = (materialComponent: MaterialComponentValue) => {
//   const materialComponentName = materialComponent.supported_component.component.name;

//   let materialComponentValue: string | undefined = undefined;
//   if (materialComponent.min_value && !materialComponent.max_value) {
//     materialComponentValue = `min: ${materialComponent.min_value}`;
//   }
//   if (materialComponent.max_value && !materialComponent.min_value) {
//     materialComponentValue = `max: ${materialComponent.max_value}`;
//   }
//   if (materialComponent.min_value && materialComponent.max_value) {
//     materialComponentValue = `${materialComponent.min_value} - ${materialComponent.max_value}`;
//   }
//   if (materialComponent.boolean_value) {
//     materialComponentValue = materialComponent.boolean_value ? 'Yes' : 'No';
//   }

//   return `${materialComponentName} ${materialComponentValue}`;
// };

const getOptionLabel = (option: BuyerMaterialSpecificationAdminListItem) => {
  if (typeof option === 'number') {
    // This may be a number (the ID) immediately after page load,
    // before the buyerMaterialSpec data is fetched. Once hydrated via the API,
    // it will be the full BuyerMaterialSpecificationAdminListItem object.
    return String(`Buyer material specification #${option}`);
  }
  const materialComponentsLabels = option.material_component_values
    .map((materialComponent) => getMaterialComponentLabel(materialComponent))
    .join(', ');
  return `${option.material.title} ${capitalizeString(option.material_form.type)} ${capitalizeString(option.material_colour?.name || '')} - ${option.material_grade.name} - ${materialComponentsLabels}`;
};

export type BuyerMaterialSpecificationsAutocompleteProps = Omit<
  AutocompleteFieldProps<BuyerMaterialSpecificationAdminListItem>,
  'options' | 'defaultValue' | 'label'
> & {
  tradeCompanyId?: number;
  defaultValue?: BuyerMaterialSpecificationAdminListItem['id'];
  label?: string;
};

export const BuyerMaterialSpecificationsAutocomplete = ({
  tradeCompanyId,
  defaultValue,
  label = 'Buyer material specification',
  ...props
}: BuyerMaterialSpecificationsAutocompleteProps) => {
  const { autocompleteProps } = useAutocomplete<BuyerMaterialSpecificationAdminListItem>({
    dataProviderName: 'trade',
    defaultValue: defaultValue,
    onSearch: (value) => [
      {
        field: 'search',
        operator: 'contains',
        value,
      },
    ],
    queryOptions: {
      enabled: Boolean(tradeCompanyId),
    },
    resource: `/v1/trade-companies/${tradeCompanyId}/buyer-material-specifications/`,
  });

  return (
    <AutocompleteField<BuyerMaterialSpecificationAdminListItem>
      {...autocompleteProps}
      {...props}
      disabled={!tradeCompanyId}
      label={label}
      getOptionLabel={(option) => getOptionLabel(option)}
      valueField="id"
      data-testid="buyer-material-specifications-autocomplete"
    />
  );
};
